import React, { useState, useEffect } from "react"

interface AddGuestModalProps {
  open: boolean
  onClose: () => void
  onSubmit: (guestName: string, guestEmail?: string) => void | Promise<void>
  isSubmitting?: boolean
}

export const AddGuestModal: React.FC<AddGuestModalProps> = ({
  open,
  onClose,
  onSubmit,
  isSubmitting = false,
}) => {
  const [guestName, setGuestName] = useState("")
  const [guestEmail, setGuestEmail] = useState("")

  useEffect(() => {
    if (open) {
      setGuestName("")
      setGuestEmail("")
    }
  }, [open])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (guestName.trim()) onSubmit(guestName.trim(), guestEmail.trim() || undefined)
  }

  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="add-guest-modal-title"
    >
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <h2
          id="add-guest-modal-title"
          className="text-xl font-bold text-gray-900 mb-4"
        >
          Add Guest List Ticket
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="guest-name"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Guest Name
            </label>
            <input
              id="guest-name"
              type="text"
              value={guestName}
              onChange={(e) => setGuestName(e.target.value)}
              placeholder="Full name"
              autoFocus
              className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none text-sm"
            />
          </div>
          <div>
            <label
              htmlFor="guest-email"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Email Address <span className="text-gray-400 font-normal">(optional)</span>
            </label>
            <input
              id="guest-email"
              type="email"
              value={guestEmail}
              onChange={(e) => setGuestEmail(e.target.value)}
              placeholder="guest@example.com"
              className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none text-sm"
            />
            <p className="text-xs text-gray-500 mt-1">
              If provided, a confirmation email will be sent to this address.
            </p>
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded hover:bg-gray-200 focus:outline-none"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting || !guestName.trim()}
              className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded hover:bg-green-700 focus:outline-none disabled:opacity-50"
            >
              {isSubmitting ? "Adding…" : "Add to Guest List"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
